module.exports = __webpack_public_path__ + "static/media/greencat2.309d5c3f.png";